import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { currencyOptions, TOAST } from 'constant';
import { TextareaInput, CurrencyInput } from 'components/FormControl';
import { toast } from 'layout';

export default function AdjustmentForm({ readOnly, control, setValue, errors, watch }) {
  // #region Data
  const { t } = useTranslation();
  const [total, setTotal] = useState({
    beforeExpenditureFromVNUHCM: 0,
    beforeExpenditureFromFunding: 0,
    afterExpenditureFromVNUHCM: 0,
    afterExpenditureFromFunding: 0,
  });

  const itemsWatch = watch('financialAdjustmentItems');

  const internationalExpertFromVNUWatch = watch(
    'financialAdjustmentItems.2.afterExpenditureFromVNUHCM'
  );
  const internationalExpertFromFundingWatch = watch(
    'financialAdjustmentItems.2.afterExpenditureFromFunding'
  );
  const domesticExpertFromVNUWatch = watch('financialAdjustmentItems.3.afterExpenditureFromVNUHCM');
  const domesticExpertFromFundingWatch = watch(
    'financialAdjustmentItems.3.afterExpenditureFromFunding'
  );

  useEffect(() => {
    if (itemsWatch?.length > 0) {
      setTotal(() => ({
        beforeExpenditureFromVNUHCM: itemsWatch.reduce(
          (acc, cur) =>
            cur?.subProposedExpenditureTypeId ? acc : acc + (cur?.beforeExpenditureFromVNUHCM || 0),
          0
        ),
        beforeExpenditureFromFunding: itemsWatch.reduce(
          (acc, cur) =>
            cur?.subProposedExpenditureTypeId
              ? acc
              : acc + (cur?.beforeExpenditureFromFunding || 0),
          0
        ),

        afterExpenditureFromVNUHCM: itemsWatch.reduce(
          (acc, cur) =>
            cur?.subProposedExpenditureTypeId ? acc : acc + (cur?.afterExpenditureFromVNUHCM || 0),
          0
        ),
        afterExpenditureFromFunding: itemsWatch.reduce(
          (acc, cur) =>
            cur?.subProposedExpenditureTypeId ? acc : acc + (cur?.afterExpenditureFromFunding || 0),
          0
        ),
      }));
      const expenditureFromVNUHCM =
        (itemsWatch?.[0].afterExpenditureFromVNUHCM || 0) -
        ((itemsWatch?.[2].afterExpenditureFromVNUHCM || 0) +
          (itemsWatch?.[3].afterExpenditureFromVNUHCM || 0));
      setValue('financialAdjustmentItems.1.afterExpenditureFromVNUHCM', expenditureFromVNUHCM);

      const expenditureFromFunding =
        (itemsWatch?.[0].afterExpenditureFromFunding || 0) -
        ((itemsWatch?.[2].afterExpenditureFromFunding || 0) +
          (itemsWatch?.[3].afterExpenditureFromFunding || 0));
      setValue('financialAdjustmentItems.1.afterExpenditureFromFunding', expenditureFromFunding);
    }
  }, [JSON.stringify(itemsWatch)]);

  useEffect(() => {
    const totalExpenditure =
      (internationalExpertFromVNUWatch || 0) + (domesticExpertFromVNUWatch || 0);
    if (totalExpenditure > watch('financialAdjustmentItems.0.afterExpenditureFromVNUHCM')) {
      toast(TOAST.ERROR, t('formControl.validation.canNotGreaterThanTotal'));
      setValue('financialAdjustmentItems.2.afterExpenditureFromVNUHCM', 0);
    }
  }, [internationalExpertFromVNUWatch]);

  useEffect(() => {
    const totalExpenditure =
      (internationalExpertFromVNUWatch || 0) + (domesticExpertFromVNUWatch || 0);
    if (totalExpenditure > watch('financialAdjustmentItems.0.afterExpenditureFromVNUHCM')) {
      toast(TOAST.ERROR, t('formControl.validation.canNotGreaterThanTotal'));
      setValue('financialAdjustmentItems.3.afterExpenditureFromVNUHCM', 0);
    }
  }, [domesticExpertFromVNUWatch]);

  useEffect(() => {
    const totalExpenditure =
      (internationalExpertFromFundingWatch || 0) + (domesticExpertFromFundingWatch || 0);
    if (totalExpenditure > watch('financialAdjustmentItems.0.afterExpenditureFromFunding')) {
      toast(TOAST.ERROR, t('formControl.validation.canNotGreaterThanTotal'));
      setValue('financialAdjustmentItems.2.afterExpenditureFromFunding', 0);
    }
  }, [internationalExpertFromFundingWatch]);

  useEffect(() => {
    const totalExpenditure =
      (internationalExpertFromFundingWatch || 0) + (domesticExpertFromFundingWatch || 0);
    if (totalExpenditure > watch('financialAdjustmentItems.0.afterExpenditureFromFunding')) {
      toast(TOAST.ERROR, t('formControl.validation.canNotGreaterThanTotal'));
      setValue('financialAdjustmentItems.3.afterExpenditureFromFunding', 0);
    }
  }, [domesticExpertFromFundingWatch]);

  return (
    <div className="form-table p-fluid">
      <table className="mb-2 w-full">
        <thead>
          <tr>
            <th className="text-center" style={{ minWidth: 50, width: 50 }}>
              {t('formLayout.numericalOrder')}
            </th>
            <th className="text-center" style={{ minWidth: 300, maxWidth: 300 }}>
              {t('financialAdjustment.table.name')}
            </th>
            <th style={{ border: 'none', padding: 0 }}>
              <table className="inner-table" style={{ minWidth: 300, height: 70 }}>
                <thead>
                  <tr>
                    <th colSpan={2}>{t('financialAdjustment.table.before')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ minWidth: 150 }}>Từ ĐHQG-HCM</td>
                    <td style={{ minWidth: 150 }}>Từ nguồn huy động</td>
                  </tr>
                </tbody>
              </table>
            </th>
            <th style={{ border: 'none', padding: 0 }}>
              <table className="inner-table" style={{ minWidth: 300, height: 70 }}>
                <thead>
                  <tr>
                    <th colSpan={2}>{t('financialAdjustment.table.after')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ minWidth: 150 }}>Từ ĐHQG-HCM</td>
                    <td style={{ minWidth: 150 }}>Từ nguồn huy động</td>
                  </tr>
                </tbody>
              </table>
            </th>

            <th className="text-center" style={{ minWidth: 200, width: '100%' }}>
              {t('financialAdjustment.table.reason')}
            </th>
          </tr>
        </thead>
        <tbody>
          {itemsWatch?.map((item, index) => (
            <tr key={item?.expenditureTypeId}>
              <td
                className={`text-center ${!item?.subProposedExpenditureTypeId && 'font-semibold'}`}
              >
                {index + 1}
              </td>
              <td>
                <TextareaInput
                  name={`financialAdjustmentItems.${index}.name`}
                  control={control}
                  errors={errors}
                  readOnly
                  className={`${!item?.subProposedExpenditureTypeId && 'font-semibold'}`}
                />
              </td>

              <td>
                <table style={{ border: 'none' }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          minWidth: 150,
                          padding: 0,
                          border: 'none',
                          paddingRight: 2,
                          width: '50%',
                        }}
                      >
                        <CurrencyInput
                          name={`financialAdjustmentItems.${index}.beforeExpenditureFromVNUHCM`}
                          control={control}
                          errors={errors}
                          readOnly
                          disabled={index === 1}
                        />
                      </th>
                      <th
                        style={{
                          minWidth: 150,
                          padding: 0,
                          border: 'none',
                          paddingLeft: 2,
                          width: '50%',
                        }}
                      >
                        <CurrencyInput
                          name={`financialAdjustmentItems.${index}.beforeExpenditureFromFunding`}
                          control={control}
                          errors={errors}
                          readOnly
                          disabled={index === 1}
                        />
                      </th>
                    </tr>
                  </thead>
                </table>
              </td>

              <td>
                <table style={{ border: 'none' }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          minWidth: 150,
                          padding: 0,
                          border: 'none',
                          paddingRight: 2,
                        }}
                      >
                        <CurrencyInput
                          name={`financialAdjustmentItems.${index}.afterExpenditureFromVNUHCM`}
                          control={control}
                          errors={errors}
                          disabled={index === 1}
                          readOnly={readOnly}
                        />
                      </th>
                      <th
                        style={{
                          minWidth: 150,
                          padding: 0,
                          border: 'none',
                          paddingLeft: 2,
                        }}
                      >
                        <CurrencyInput
                          name={`financialAdjustmentItems.${index}.afterExpenditureFromFunding`}
                          control={control}
                          errors={errors}
                          disabled={index === 1}
                          readOnly={readOnly}
                        />
                      </th>
                    </tr>
                  </thead>
                </table>
              </td>

              <td>
                <TextareaInput
                  name={`financialAdjustmentItems.${index}.reason`}
                  control={control}
                  errors={errors}
                  readOnly={readOnly}
                  disabled={index === 1}
                />
              </td>
            </tr>
          ))}

          <tr key={100} style={{ height: 36 }}>
            <td className="text-center" />
            <td className="font-bold">Tổng cộng</td>

            <td>
              <table style={{ border: 'none' }}>
                <thead>
                  <tr>
                    <th
                      className="text-right font-bold bg-white"
                      style={{
                        minWidth: 150,
                        padding: 0,
                        border: 'none',
                        paddingRight: 2,
                        borderRight: 1,
                      }}
                    >
                      {total.beforeExpenditureFromVNUHCM.toLocaleString('vi', currencyOptions)}
                    </th>
                    <th
                      className="text-right font-bold bg-white"
                      style={{
                        minWidth: 150,
                        padding: 0,
                        border: 'none',
                        paddingLeft: 2,
                      }}
                    >
                      {total.beforeExpenditureFromFunding.toLocaleString('vi', currencyOptions)}
                    </th>
                  </tr>
                </thead>
              </table>
            </td>

            <td>
              <table style={{ border: 'none', backgroundColor: '#fff' }}>
                <thead>
                  <tr>
                    <th
                      className="text-right font-bold bg-white"
                      style={{ minWidth: 150, padding: 0, border: 'none', paddingRight: 2 }}
                    >
                      {total.afterExpenditureFromVNUHCM.toLocaleString('vi', currencyOptions)}
                    </th>
                    <th
                      style={{
                        minWidth: 150,
                        padding: 0,
                        border: 'none',
                        paddingLeft: 2,
                      }}
                      className="text-right font-bold bg-white"
                    >
                      {total.afterExpenditureFromFunding.toLocaleString('vi', currencyOptions)}
                    </th>
                  </tr>
                </thead>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

AdjustmentForm.propTypes = {
  readOnly: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

AdjustmentForm.defaultProps = {
  readOnly: false,
};
